<div class="container-full has-background-white-bis">
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="country">
  <section class="hero is-primary mt-4 mb-8">
    <div class="container-full">
      <div class="container">
        <div class="columns">
          <div class="column is-12">
            <div class="hero-body px-0 py-8">
              <div
                class="hero-cover"
                style="background-image: url('./assets/images/covers/{{
                  country.image
                }}.png')"
              ></div>
              <div class="columns">
                <div class="column is-6">
                  <div class="is-flex align-items-center my-4 is-fullwidth">
                    <img
                      class="flag mr-3"
                      src="./assets/images/flags/{{ country.image }}.png"
                      alt="{{ country.label }} flag"
                    />
                    <h1 class="title is-2 has-text-weight-bold">
                      {{ country.label }}
                      <span
                        *ngIf="country.label === 'Cyprus'"
                        class="has-tooltip has-tooltip-right has-tooltip-multiline has-tooltip-large"
                        [attr.data-tooltip]="cyprusNote"
                      >
                        <i
                          class="fa-solid fa-circle-info is-size-5 has-text-link ml-2"
                        ></i>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <!-- Main container -->
        <nav class="level is-flex mb-2">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <h2 class="title is-3 has-text-weight-bold has-line">
                R&D tax incentives in {{ country.label }}
              </h2>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right is-flex">
            <div class="level-item">
              <div class="field has-addons">
                <p class="control">
                  <a class="button is-small is-link-light is-hidden-desktop">
                    <span class="icon is-small">
                      <i class="fa-solid fa-file-export"></i>
                    </span>
                  </a>
                  <a
                    class="button is-link-light is-hidden-touch"
                    [ngClass]="{
                      'is-loading': loadingDownload
                    }"
                    (click)="downloadIncentives(country.incentiveIds)"
                  >
                    <span>Export incentives</span>
                    <span class="icon is-small">
                      <i class="fa-solid fa-file-export"></i>
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </nav>
        <div [innerHTML]="country.description"></div>
      </div>
    </div>
  </div>

  <app-incentive-comparator
    *ngIf="country.incentiveIds"
    [incentiveIds]="country.incentiveIds"
    [isFavoriteButtonDisplayed]="true"
    [isShowSimilarDisplayed]="true"
    [mode]="incentiveModeCountryView"
    sortBy="f:active"
  ></app-incentive-comparator>

  <!-- Policy Changes -->
  <div class="container mt-4">
    <div class="columns">
      <div class="column is-12">
        <div class="card is-shadowless has-background-white-bis">
          <div class="card-content">
            <div id="collapsible-content">
              <div
                (click)="isPolicyChangesExtended = !isPolicyChangesExtended"
                class="accordion-header py-4 is-flex is-align-items-center is-justify-content-space-between"
              >
                <h2 class="title is-3 has-text-weight-bold mb-0">
                  Recent policy developments
                </h2>
                <a class="button is-light is-circle">
                  <i
                    class="fa-solid fa-angle-down"
                    [ngClass]="{
                      'has-rotated': isPolicyChangesExtended
                    }"
                  ></i>
                </a>
              </div>
              <div
                class="is-collapsible"
                [ngClass]="{ 'is-active': isPolicyChangesExtended }"
              >
                <div class="table-container is-fullwidth">
                  <!-- Group policy changes by incentiveLabel -->
                  <div
                    *ngFor="
                      let incentiveGroup of groupPolicyChangesByIncentive(
                        country.policyChanges
                      )
                    "
                  >
                    <table
                      class="table is-fullwidth is-narrow is-bordered has-background-white-bis content is-small"
                    >
                      <thead>
                        <tr class="has-background-white">
                          <th colspan="2">
                            {{ incentiveGroup.incentiveLabel }}
                          </th>
                        </tr>
                      </thead>
                      <tbody *ngFor="let yearGroup of incentiveGroup.years">
                        <tr>
                          <td colspan="2">
                            <strong>{{ yearGroup.year }}</strong>
                          </td>
                        </tr>
                        <tr *ngFor="let field of yearGroup.fields">
                          <td width="280" *ngIf="fieldLabels?.[field.id]">
                            <strong>{{ fieldLabels[field.id] }}</strong>
                          </td>
                          <td>{{ field.value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- Message if no policy changes -->
                  <table *ngIf="!country.policyChanges.length">
                    <tbody class="tbody">
                      <tr>
                        <td colspan="2">
                          In 2023, {{ country.label }} did not undertake changes
                          in its R&D tax relief provisions.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Charts -->
  <div class="container mt-4" *ngFor="let group of country.aggregationGroups">
    <div class="columns">
      <div class="column">
        <h2 class="title is-3 has-text-weight-bold has-line">
          {{ group.label }}
        </h2>
        <h3 *ngIf="group.subTitle" class="title is-5 has-text-weight-bold">
          {{ group.subTitle }}
        </h3>
        <p *ngIf="group.description">{{ group.description }}</p>
      </div>
    </div>
    <app-aggregation-widget
      [aggregations]="group.aggregations"
    ></app-aggregation-widget>
  </div>

  <!--Compare countries -->
  <div class="container mt-4 mb-8">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h2 class="title is-3 has-text-weight-bold has-line">
          Compare the incentives in {{ country.label }} with those in other
          countries
        </h2>
      </div>
      <div
        class="column is-12-mobile is-4-tablet is-3-desktop py-0"
        *ngFor="let comparativeCountry of countries"
      >
        <a
          routerLink="/incentives"
          [queryParams]="{
            'f:Country': [comparativeCountry.label, country.label]
          }"
          class="button is-small is-fullwidth is-square is-white is-flex is-align-items-center is-justify-content-flex-start"
        >
          <img
            class="flag is-small mr-2"
            src="./assets/images/flags/{{ comparativeCountry.image }}.png"
            alt="{{ comparativeCountry.label }} flag"
          />
          <span class="has-text-weight-normal">{{
            comparativeCountry.label
          }}</span>
        </a>
      </div>

      <app-country-detail-loader *ngIf="!countries"></app-country-detail-loader>
    </div>
  </div>
</ng-container>
